import React from 'react';
export function PrivacyContent() {
  return <div className="space-y-6" data-id="element-284">
      <section data-id="element-285">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-286">
          1. Compromiso de Privacidad
        </h4>
        <p data-id="element-287">
          En Estrategias Digitales A-Z, respetamos su privacidad y estamos
          comprometidos a proteger sus datos personales. Esta política describe
          cómo recopilamos, usamos y protegemos la información que nos
          proporciona.
        </p>
      </section>

      <section data-id="element-288">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-289">
          2. Información que Recopilamos
        </h4>
        <p data-id="element-290">
          Podemos recopilar la siguiente información cuando nos contacta o
          contrata nuestros servicios:
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-291">
          <li data-id="element-292">
            Información de contacto: Nombre, correo electrónico, número de
            teléfono.
          </li>
          <li data-id="element-293">
            Información del negocio: Detalles sobre su empresa, objetivos y
            requerimientos del proyecto.
          </li>
          <li data-id="element-294">
            Datos técnicos: Dirección IP y datos de navegación para mejorar la
            experiencia en nuestro sitio (cookies).
          </li>
        </ul>
      </section>

      <section data-id="element-295">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-296">
          3. Uso de la Información
        </h4>
        <p data-id="element-297">Utilizamos sus datos exclusivamente para:</p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-298">
          <li data-id="element-299">Proveer los servicios contratados (diseño web, consultoría).</li>
          <li data-id="element-300">Comunicarnos con usted sobre el estado de su proyecto.</li>
          <li data-id="element-301">
            Enviar información relevante o promociones (si ha dado su
            consentimiento).
          </li>
          <li data-id="element-302">
            Facturación y cumplimiento de obligaciones legales en Costa Rica.
          </li>
        </ul>
      </section>

      <section data-id="element-303">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-304">
          4. Protección de Datos
        </h4>
        <p data-id="element-305">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger sus datos contra acceso no autorizado, pérdida o alteración.
          No vendemos, alquilamos ni compartimos su información personal con
          terceros con fines comerciales.
        </p>
      </section>

      <section data-id="element-306">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-307">5. Sus Derechos</h4>
        <p data-id="element-308">
          Usted tiene derecho a acceder, rectificar, cancelar u oponerse al
          tratamiento de sus datos personales. Para ejercer estos derechos,
          puede contactarnos directamente a través de nuestros canales
          oficiales.
        </p>
      </section>

      <section data-id="element-309">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-310">6. Contacto</h4>
        <p data-id="element-311">
          Si tiene preguntas sobre nuestra política de privacidad o el manejo de
          sus datos, contáctenos en:
        </p>
        <p className="mt-2 text-purple-400" data-id="element-312">
          Correo: holaestrategiasaz@gmail.com
          <br data-id="element-313" />
          Teléfono: +506 8531-6690
          <br data-id="element-314" />
          Ubicación: San José, Costa Rica
        </p>
      </section>

      <div className="pt-4 text-sm text-gray-500 border-t border-white/10" data-id="element-315">
        Última actualización: Febrero 2026
      </div>
    </div>;
}